import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RegistrationPage.css';
import { notification, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import axios from 'axios';
import { getApiUrl } from '../utils/configHelper';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

function RegistrationPage() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const { canInstall, installApp } = useInstallPrompt();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Basic validation
    if (firstName.trim() === '' || lastName.trim() === '' || phoneNo.trim() === '' || password.trim() === '' || confirmPassword.trim() === '') {
      notification.error({
        message: 'Error',
        description: 'Please fill all fields.',
      });
      return;
    }

    if (password !== confirmPassword) {
      notification.error({
        message: 'Error',
        description: 'Passwords do not match.',
      });
      return;
    }

    if (phoneNo.length < 8) {
      notification.error({
        message: 'Error',
        description: 'Please enter a valid phone number.',
      });
      return;
    }

    // Format phone
    let formattedPhone = phoneNo.replace(/\D/g, ''); // remove non-digits
    if (formattedPhone.startsWith('0')) {
      formattedPhone = '211' + formattedPhone.substring(1);
    } else {
      formattedPhone = '211' + formattedPhone;
    }

    try {
      const apiUrl = getApiUrl();
      const response = await axios.post(`${apiUrl}/auth/register`, {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        phoneNo: formattedPhone,
        password,
      });

      if (response.data.status === true) {
        notification.success({
          message: 'Success',
          description: 'Registration successful! Please login.',
        });
        navigate('/');
      } else {
        notification.error({
          message: 'Error',
          description: response.data.result,
        });
      }
    } catch (error) {
      let errorMessage = 'Failed to register. Please try again.';
      if (error.response && error.response.data && error.response.data.result) {
        errorMessage = error.response.data.result;
      }
      notification.error({
        message: 'Error',
        description: errorMessage,
      });
    }
  };

  return (
    <div className="registration-container">
      <h1>Register</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Enter your first name"
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Enter your last name"
          />
        </div>
        <div className="form-group">
          <label htmlFor="phoneNo">Phone Number:</label>
          <div className="phone-input">
            <span className="prefix">+211</span>
            <input
              type="tel"
              id="phoneNo"
              value={phoneNo}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '').slice(0, 9); // only digits, max 9
                setPhoneNo(value);
              }}
              placeholder="912345678"
              maxLength="9"
            />
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm your password"
          />
        </div>
        <button type="submit">Register</button>
      </form>
      <p>Already have an account? <a href="/">Login</a></p>
      {canInstall && (
        <Button
          onClick={installApp}
          style={{
            marginTop: '40px',
            backgroundColor: 'white',
            color: 'green',
            border: '1px solid green',
            outline: 'none',
          }}
        >
          <DownloadOutlined style={{ border: '1px solid green' }} /> Install App
        </Button>
      )}
    </div>
  );
}

export default RegistrationPage;